import styled from "styled-components"

import Heading from "./Heading"

const H3 = styled.h3`
  ${Heading}

  font-size: 30px;
`

export default H3
